/**
 * Sub1 Template
 * @category testApp
 */
class ListinfoTempl {
    /**
     * Sub1 Templ
     * @param  {Object} _d={}
     * @param  {Object} _config={}
     */
    static getTempl(_d={}, _config={}) {
        let profileUrl = _config.profileImg;
        const list = _d.map(arrayItem => ListinfoTempl.listItemTempl(arrayItem,profileUrl)).join('');
        return `
        ${list}
        `;
    }
    static listItemTempl(_d, _profileUrl){
        let characterLink = _profileUrl + _d.profileImageUrl;
        return `
        <li><a href="${_d.characterHome}" class="character-list-link">
            <div class="character-list-thumbnail-wrap">
                <span class="character-list-thumbnail"><img src="${characterLink}" alt="" width="80" height="80"></span>
            </div>
            <div class="character-list-info-wrap">
                <div class="character-list-info">
                    <strong class="character-list-name">${_d.name}</strong>
                    <div class="character-sub-info-wrap">
                        <span class="character-sub-info">${_d.jobName}</span>
                        <span class="character-sub-info">${_d.serverName}</span>
                        <span class="character-sub-info"><em>Lv.${_d.level}</em>${_d.masteryFactionName ?  `<em>${_d.masteryFactionName}${_d.masteryLevel}성</em>` : ``}</span>
                    </div>
                    <em class="character-pr-text">${_d.guild ? _d.guild.guildName : '문파없음'}</em>
                </div>
            </div>
        </a></li>    
        `;
    }
} // end of class

export default ListinfoTempl;